import StoreUpdateEvents from "../constants/events/StoreUpdateEvents";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import LoadingStates from "../constants/states/LoadingStates";
import ActionResultEvents from "../constants/events/ActionResultEvents";
import SecureBaseStore from "./SecureBaseStore";
import Time from "../utils/Time";


class SpaceBalanceState {
    constructor(
        loadingState,
        selectedYear,
        selectedMonth,
        monthBalanceEvents
    ) {
        this.loadingState = loadingState;
        this.selectedYear = selectedYear;
        this.selectedMonth = selectedMonth;
        this.monthBalanceEvents = monthBalanceEvents;
    }

    equals(other) {
        return this.loadingState === other.loadingState &&
            this.selectedYear === other.selectedYear &&
            this.selectedMonth === other.selectedMonth &&
            this.monthBalanceEvents.priorEarnings === other.monthBalanceEvents.priorEarnings &&
            this.monthBalanceEvents.priorPayouts === other.monthBalanceEvents.priorPayouts &&
            this.monthBalanceEvents.earningsEvents.length === other.monthBalanceEvents.earningsEvents.length &&
            this.monthBalanceEvents.payoutEvents.length === other.monthBalanceEvents.payoutEvents.length; //TODO - move these checks to the DTO
    }
}

class ImmutableSpaceBalanceStateBuilder {

    constructor() {
        this.loadingState = LoadingStates.INITIALIZED;
        this.selectedYear = Time.getCurrentYear();
        this.selectedMonth = Time.getCurrentMonth();
        this.monthBalanceEvents = {
            priorEarnings: 0.0,
            priorPayouts: 0.0,
            earningsEvents: [],
            payoutEvents: []
        }
    }

    static fromState(state) {
        return new ImmutableSpaceBalanceStateBuilder()
            .setLoadingState(state.loadingState)
            .setMonthBalanceEvents(state.monthBalanceEvents)
            .setSelectedDate(state.selectedYear, state.selectedMonth);
    }

    setLoadingState(loadingState) {
        this.loadingState = loadingState;
        return this;
    }

    setMonthBalanceEvents(monthBalanceEvents) {
        this.monthBalanceEvents = monthBalanceEvents;
        return this;
    }

    setSelectedDate(selectedYear, selectedMonth) {
        this.selectedYear = selectedYear;
        this.selectedMonth = selectedMonth;
        return this;
    }

    build() {
        return Object.freeze(new SpaceBalanceState(this.loadingState, this.selectedYear, this.selectedMonth, this.monthBalanceEvents));
    }
}


class SpaceBalanceStore extends SecureBaseStore {

    constructor() {
        super(StoreUpdateEvents.SPACE_BALANCE_STORE_UPDATE, ImmutableSpaceBalanceStateBuilder);
        this.subscribeToEvent(ActionResultEvents.SPACE_BALANCE_LOADED, this.handleBalanceLoaded);
        this.subscribeToEvent(UIInteractionEvents.SPACE_BALANCE_MOUNTED, this.handleLoading);
        this.subscribeToEvent(UIInteractionEvents.SPACE_BALANCE_SELECTED_MONTH_CHANGED, this.handleMonthChanged);
        this.subscribeToEvent(UIInteractionEvents.SPACE_BALANCE_UNMOUNTED, this.resetStore);
    }

    handleLoading = (topic, data) => {
        return ImmutableSpaceBalanceStateBuilder.fromState(this.state)
            .setLoadingState(LoadingStates.LOADING)
            .build();
    };

    handleMonthChanged = (topic, data) => {
        return ImmutableSpaceBalanceStateBuilder.fromState(this.state)
            .setLoadingState(LoadingStates.LOADING)
            .setSelectedDate(data.selectedYear, data.selectedMonth)
            .build();
    };

    handleBalanceLoaded = (topic, data) => {
        return ImmutableSpaceBalanceStateBuilder.fromState(this.state)
            .setLoadingState(LoadingStates.FINISHED_LOADING)
            .setMonthBalanceEvents(data)
            .build();
    };

}

export default new SpaceBalanceStore();